import api from '@/lib/services/general.service'
import { toast } from 'vue3-toastify';

export const state = {
    emails: {
        items: [],
        index: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: 0,
        hasNextPage: 0,
    },
    spamEmails: {
        items: [],
        index: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: 0,
        hasNextPage: 0,
    },
    draftEmails: {
        items: [],
        index: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: 0,
        hasNextPage: 0,
    },
    isLoading: false,


}
export const getters = {
    emails: s => s.emails,
    spamEmails: s => s.spamEmails,
    draftEmails: s => s.draftEmails,
    isLoading: s => s.isLoading,
};
export const actions = {
    async postEmail({ dispatch }, email) {
        const silent = !!email.silentToast
        delete email.silentToast
        const toastId = silent ? null : toast.loading(
            'Sending Message ...',
            {
                theme: 'email',
            }
        );
        const response = await api.insert('email', email)
        if (response) {
            if (response.data && response.data.id) {
                dispatch('timeline/addEmailIntoTimeline', response.data, { root: true });
                dispatch('sidepanel/addEmailIntoTimeline', response.data, { root: true });
            }
            if (!silent) setTimeout(() => {
                toast.update(toastId, {
                    render: 'Message Sent',
                    autoClose: true,
                    closeOnClick: true,
                    closeButton: true,
                    theme: 'email',
                    isLoading: false,
                });
                toast.done(toastId);
            });
            // The created email carries the thread it belongs to — callers (e.g. composing inside an
            // ongoing) use it to link the new thread back to that ongoing.
            return response.data
        }
        // A send that answered nothing still has to close its spinner (busy-my-web#247). A loading
        // notification has no timeout of its own — that is the point of it — so the one path that
        // never updated it left it on screen for the rest of the session, with every later
        // notification stacking above it.
        if (toastId) toast.done(toastId);
        return null
    },
    /**
     * SCHEDULE SEND (busy-my-web#158 / busy-main-bff#14). The same `POST /v1/email` route as
     * `postEmail` — a `sendAtUtc` in the future is the only difference, and the BFF parks the mail
     * in its scheduled sorted set instead of the fire-immediately queue.
     *
     * Deliberately NOT `postEmail`: that one announces "Message Sent" and pushes the mail onto the
     * timeline, and neither is true yet of a message that is still waiting on a clock. The answer
     * here is the schedule record `{ id, subject, sendAt, recipients }` — the box keeps its `id`
     * because that is what Undo cancels by.
     */
    async scheduleSend(_, email) {
        const response = await api.insert('email', email)
        return response?.data ?? null
    },
    /** The caller's mail still waiting on the clock, soonest first. */
    async fetchScheduledEmails() {
        const response = await api.get('email/scheduled', {})
        return response?.data ?? []
    },
    /**
     * Undo, before the moment: the scheduled mail is removed entirely. The BFF answers 404 once it
     * is gone, which axios raises — the caller has to know a cancel failed rather than tell the user
     * a message was pulled back when it was already on its way.
     */
    async cancelScheduledSend(_, scheduleId) {
        const response = await api.delete('email/scheduled', scheduleId)
        return !!response
    },
    // `silentToast` (busy-my-web#245): the SmartBox composer reports a send itself, in one place,
    // with View message and Undo on it — so the store's own announcement stands down for that
    // caller. Same opt-in flag `postEmail` already takes; every other caller is unchanged.
    async postEmailReply({ dispatch }, {id,email,silentToast}) {
        const silent = !!silentToast
        const toastId = silent ? null : toast.loading(
            'Sending Message ...',
            {
                theme: 'email',
            }
        );
        const response = await api.insertWithPath('email', id +'/reply', email)
        if (response) {
            if (response.data && response.data.id) {
                dispatch('timeline/addEmailIntoTimeline', response.data, { root: true });
                dispatch('sidepanel/addEmailIntoTimeline', response.data, { root: true });
            }
            if (!silent) setTimeout(() => {
                toast.update(toastId, {
                    render: 'Message Sent',
                    autoClose: true,
                    closeOnClick: true,
                    closeButton: true,
                    theme: 'email',
                    isLoading: false,
                });
                toast.done(toastId);
            });
            return response.data
        }
        // …and the spinner closes whatever the answer was (busy-my-web#247).
        if (toastId) toast.done(toastId);
        return null
    },
    async fetchEmails({ commit }, requestData) {
        return await api.get(`email`, requestData).then(response => {
            if (response) {
                commit("SET_EMAILS", response.data);
            }
            return true;
        });
    },
    async fetchSpamsEmails({ commit }, requestData) {
        commit("SET_LOADING", true);
        return await api.get(`email/spam`, requestData).then(response => {
            if (response) {
                commit("SET_SPAM_EMAILS", response.data);
            }
            return true;
        });
    },
    async fetchDraftsEmails({ commit }, requestData) {
        return await api.get(`email/draft`, requestData).then(response => {
            if (response) {
                commit("SET_DRAFT_EMAILS", response.data);
            }
            return true;
        });
    },
}
export const mutations = {
    SET_EMAILS(s, emails) {
        s.emails = emails;
        s.isLoading = false;
    },
    SET_SPAM_EMAILS(s, emails) {
        s.spamEmails = emails;
        s.isLoading = false;
    },
    SET_LOADING(s, loading) {
        s.isLoading = loading;

    },
    SET_DRAFT_EMAILS(s, emails) {
        s.draftEmails = emails;
        s.isLoading = false;
    }
}
export default {
    state,
    getters,
    actions,
    mutations
};